module.exports = __webpack_public_path__ + "static/media/neuschwanstein-castle-germany.1ac8927f.jpg";